export default {"src":"/_next/static/media/hero.520a9329.svg","height":212,"width":309,"blurWidth":0,"blurHeight":0};